// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_85-0";
export var headerCellHover = "_85-1";
export var readCellContainer = "_85-2";
export var readCellSlot = "_85-3";
export var rowHoverCheckbox = "_85-4";
export var rowUnreadIndicator = "_85-5";
export var searchHighlight = "_85-8";
export var supportTicketRow = "_85-6";
export var unreadIndicator = "_85-7";